module.exports = "/_next/static/images/tile1-66b6685432728bc15f0d05adbf0c9a04.png";